import { cva } from '@membranehq/ui/styled-system/css'

export const popupCvaRecipe = cva({
  base: {
    w: 'full',
    maxW: 'min(37.5rem, 100%)',
    minH: 'min(39.5rem, 100%)',
    maxH: 'min(45.5rem, 100%)',
    transitionProperty: 'width,height,max-width,max-height,min-width,min-height',
    transitionDuration: 'normal',
    transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
  },
  variants: {
    horizontal: {
      wide: {
        maxW: '70rem',
      },
    },
  },
})
